import VerticalTabs from "common/ComponentSidebar/ComponentSideBar";
import { checkPrivileges } from "Helpers/CheckPrivileges";
import { useNavigate } from "react-router-dom";

interface tabProps {
    params: any;
    selectedIndex: number;
}
export default function VehicleTabs(props: tabProps) {
    const navigate = useNavigate();
    const handleChangeTabs = (tabId: number) => {
        if (tabId === 0) navigate(`/vehicle/${props.params?.id}`);
        else if (tabId === 1) navigate(`/vehicle/${props.params?.id}/bookings`);
        else if (tabId === 2) navigate(`/vehicle/${props.params?.id}/job-cards`);
        else if (tabId === 3) navigate(`/vehicle/${props.params?.id}/work-orders`);
        else if (tabId === 4) navigate(`/vehicle/${props.params?.id}/invoices`);
        else if (tabId === 5) navigate(`/vehicle/${props.params?.id}/inspections`);
        else if (tabId === 6) navigate(`/vehicle/${props.params?.id}/payments`);
        else if (tabId === 7) navigate(`/vehicle/${props.params?.id}/service-recommendations`);
        else if (tabId === 8) navigate(`/vehicle/${props.params?.id}/service-history`);
    }
    const tabs = [
        { id: 0, title: `edit`, child: <></> },
        { id: 1, title: `Bookings`, child: <></> },
        { id: 2, title: `jobCards`, child: <></> },
        { id: 3, title: `workOrders`, child: <></> },
        { id: 4, title: `invoices`, child: <></> },
        { id: 5, title: `Inspections`, child: <></> },
        { id: 6, title: `payments`, child: <></> },
        { id: 7, title: `serviceRecommendations`, child: <></> },
        { id: 8, title: `serviceHistory`, child: <></> },
    ];
    const disableTabs = tabs.map(tab => tab.id).filter(tabId => {
        switch (tabId) {
            case 0:
                return !checkPrivileges('ROLE_VEHICLE_UPDATE');
            case 1:
                return !checkPrivileges('ROLE_BOOKING_VIEW');
            case 2:
                return !checkPrivileges('ROLE_JOBCARD_VIEW');
            case 3:
                return !checkPrivileges('ROLE_WORKORDER_VIEW');
            case 4:
                return !checkPrivileges('ROLE_INVOICE_VIEW');
            case 5:
                return !checkPrivileges('ROLE_VEHICLEINSPECTION_VIEW');
            case 6:
                return !checkPrivileges('ROLE_PAYMENT_VIEW');
            case 7:
                return !checkPrivileges('ROLE_RECOMMENDEDSERVICE_VIEW');
            case 8:
                return !checkPrivileges('ROLE_VEHICLE_SERVICE_HISTORY_VIEW');
            default:
                return false;
        }
    });

    return (<>
        <VerticalTabs tabs={tabs} selectedIndex={props.selectedIndex} handleChangeTabs={handleChangeTabs} disableTabNo={disableTabs} />
    </>);
}